import './static/fonts/fonts.css'
